// src/components/PlaceholderState.jsx  —  ohapotato v2026.10.36
import React from 'react';

const SUGGESTIONS = [
  { emoji: '🥚', label: 'Quick breakfast',  items: ['Eggs', 'Cheese', 'Spinach'],                    mealType: 'breakfast' },
  { emoji: '🍗', label: 'Easy chicken',     items: ['Chicken Breast', 'White Rice', 'Broccoli'],      mealType: 'dinner' },
  { emoji: '🍝', label: 'Weeknight pasta',  items: ['Pasta', 'Tomatoes', 'Mozzarella'],               mealType: 'dinner' },
  { emoji: '🌮', label: 'Taco night',       items: ['Ground Beef', 'Taco Shells', 'Black Beans'],     mealType: 'dinner' },
  { emoji: '🥗', label: 'Light lunch',      items: ['Lettuce', 'Avocado', 'Lemon'],                   mealType: 'lunch' },
  { emoji: '🍲', label: 'Warming soup',     items: ['Chicken Broth', 'Carrot', 'Potato'],             mealType: 'dinner' },
];

export default function PlaceholderState({ onSuggest }) {
  return (
    <div style={styles.wrap}>
      <div style={styles.icon}>🥘</div>
      <h3 style={styles.title}>Select 2+ ingredients to get started</h3>
      <p style={styles.text}>
        Choose your ingredients, or jump in with one of these combos:
      </p>

      <div style={styles.suggestions}>
        {SUGGESTIONS.map(s => (
          <button
            key={s.label}
            style={styles.suggBtn}
            onClick={() => onSuggest?.(s.items, s.mealType)}
            title={`Try: ${s.items.join(', ')}`}
          >
            <span style={styles.suggEmoji}>{s.emoji}</span>
            <div style={styles.suggText}>
              <span style={styles.suggLabel}>{s.label}</span>
              <span style={styles.suggItems}>{s.items.join(' · ')}</span>
            </div>
            <span style={styles.suggArrow}>→</span>
          </button>
        ))}
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    background: 'var(--bg-card)',
    border: '1.5px dashed var(--border-base)',
    borderRadius: 'var(--radius-lg)',
    padding: '36px 24px',
    textAlign: 'center',
    animation: 'fadeUp 0.4s ease',
    transition: 'background 0.3s ease, border-color 0.3s ease',
  },
  icon: { fontSize: '40px', marginBottom: '12px' },
  title: {
    fontFamily: 'var(--font-display)',
    fontSize: '18px',
    fontWeight: '400',
    marginBottom: '8px',
    color: 'var(--text-primary)',
    transition: 'color 0.3s ease',
  },
  text: {
    fontFamily: 'var(--font-body)',
    fontSize: '13px',
    color: 'var(--text-muted)',
    marginBottom: '20px',
    lineHeight: '1.5',
  },
  suggestions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxWidth: '340px',
    margin: '0 auto',
  },
  suggBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '11px 15px',
    background: 'var(--bg-surface)',
    border: '1px solid var(--border-base)',
    borderRadius: 'var(--radius-md)',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'border-color var(--transition), background var(--transition)',
    fontFamily: 'var(--font-body)',
  },
  suggEmoji: { fontSize: '20px', flexShrink: 0 },
  suggText: { flex: 1, display: 'flex', flexDirection: 'column', gap: '2px' },
  suggLabel: { fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)' },
  suggItems: { fontSize: '13px', color: 'var(--text-muted)' },
  suggArrow: { fontSize: '13px', color: 'var(--text-muted)', flexShrink: 0 },
};
